import React from 'react';
import { Card, CardContent, CardHeader,
  Container, Divider, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, colors
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import 'date-fns';
import { useEffect, useState } from 'react';
import Header from 'src/components/Header';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';


const useStyles = makeStyles((theme) => ({
  success: {
    backgroundColor: colors.green[600],
    color: theme.palette.common.white
  },
  info: {
    backgroundColor: colors.lightBlue[600],
    color: theme.palette.common.white
  },
  warning: {
    backgroundColor: colors.yellow[900],
    color: theme.palette.common.white
  },
  error: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText
  },
  root: {
    paddingTop: theme.spacing(3),
    flexGrow: 1
  },
  TableCellHeader: {
    backgroundColor: '#eee',
    fontWeight: 'bold',
    width: '5%',
    align: 'left'
  },
  cardHeader: {
    flexGrow: 1
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  searchDF: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconDF: {
    marginRight: theme.spacing(0),
    color: theme.palette.icon
  },
  searchInputDF: {
    flexGrow: 1
  },
  fieldsGaranti: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  contentGaranti: {
    minHeight: 430,
  },
  submitButtonAeee: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
}));


function ExtraWarrantySalesList({ className }) {
  const classes = useStyles();
  const user = getUser();
  const [Data, setData] = useState([]);




  useEffect(() => {
    axios.get(`/GetArtemisExtraWarrantyPriceList/${user.OrganizationUserId}`).then((response) => {
      const ResponseData = response.data;
      if (ResponseData.length === 0) {
        setData([]);
      } else {
        setData(ResponseData);
      }
    });
  }, [user.OrganizationUserId]);



  return (
    <Page className={classes.root} title="Ek Garanti Satış Takip">
      <Container maxWidth="lg">
        <Header />
        <Card
          className={clsx(classes.cardHeader, className)}
        >
          <CardHeader title="Ek Garanti Satış Takip" />
          <Divider />         
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={6} md={6}>
                <Typography variant="body1">
                  Hedef
                </Typography>
              </Grid>
              <Grid item xs={6} md={6} align="right">
                <Typography variant="h6">
                  {Data[0]?.HEDEF}
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant="body1">
                  Kalan
                </Typography>
              </Grid>
              <Grid item xs={6} md={6} align="right">
                <Typography variant="h6">
                  {Data[0]?.HEDEF_KALAN_TOPLAM}
                </Typography>
              </Grid>
              <Grid item xs={12} md={12}>
                <Divider />
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant="body1">
                  Servis Satış
                </Typography>
              </Grid>
              <Grid item xs={6} md={6} align="right">
                <Typography variant="h6">
                  {Data[0]?.SERVIS_YIL_SATIS}
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant="body1">
                  Servis Adet
                </Typography>
              </Grid>
              <Grid item xs={6} md={6} align="right">
                <Typography variant="h6">
                  {Data[0]?.SERVIS_YIL_SATIS_ADET}
                </Typography>
              </Grid>
              <Grid item xs={12} md={12}>
                <Divider />
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant="body1">
                  Çağrı Merkezi Satış
                </Typography>
              </Grid>
              <Grid item xs={6} md={6} align="right">
                <Typography variant="h6">
                  {Data[0]?.CAGRI_MERKEZI_YIL_SATIS}
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant="body1">
                  Çağrı Merkezi Adet
                </Typography>
              </Grid>
              <Grid item xs={6} md={6} align="right">
                <Typography variant="h6">
                  {Data[0]?.CAGRI_MERKEZI_YIL_SATIS_ADET}
                </Typography>
              </Grid>
              <Grid item xs={12} md={12}>
                <Divider />
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant="body1">
                  Toplam Satış
                </Typography>
              </Grid>
              <Grid item xs={6} md={6} align="right">
                <Typography variant="h6">
                  {Data[0]?.TOPLAM_SATIS}
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant="body1">
                  Toplam Adet
                </Typography>
              </Grid>
              <Grid item xs={6} md={6} align="right">
                <Typography variant="h6">
                  {Data[0]?.TOPLAM_SATIS_ADET}
                </Typography>
              </Grid>
              <Grid item xs={12} md={12}>
                <Divider />
              </Grid>
            </Grid>

          </CardContent>
          <Divider />
          <CardContent>
            <TableContainer style={{ width: '100%' }}>
              <Table
                stickyHeader
                aria-labelledby="tableTitle"
                size="small"
              >
                <TableHead>
                  <TableRow>
                    <TableCell colSpan={3} align="center">Bügünkü Satışlar</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Kanal</TableCell>
                    <TableCell>Adet</TableCell>
                    <TableCell align="right">Tutar(₺)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Data.map(row => (
                    <TableRow>
                      <TableCell>{row.SATIS_KANALI}</TableCell>
                      <TableCell>{row.ADET}</TableCell>
                      <TableCell align="right">{row.FIYAT}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableHead>
                  <TableRow>
                    <TableCell>Toplam</TableCell>
                    <TableCell>{Data[0]?.GUN_TOPLAM_ADET}</TableCell>
                    <TableCell align="right">{Data[0]?.GUN_TOPLAM_FIYAT}</TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Container>

    </Page >
  );
}

export default ExtraWarrantySalesList;
